import classNames from 'classnames';
import { useCallback } from 'react';
import { Flex, Heading } from 'yoso';
import { BrandLikeButton } from '~/components/Dosi/Brand/Like/BrandLikeButton';
import { DosiProfileNav } from '~/components/Dosi/Nav/DosiProfileNav';
import { Dropdown } from '~/components/Dropdown/Dropdown';
import { useMember } from '~/components/Member/Member.hooks';
import { Link } from '~/components/Route/Link';
import styles from './ProfileDropdown.module.scss';

export type ProfileDropdownProps = {
  className?: string;
};

export const ProfileDropdown = ({ className }: ProfileDropdownProps) => {
  const {
    data: { profileImageUrl, nickname },
  } = useMember();

  const handleClickLikeButton = useCallback((e) => {
    e.stopPropagation();
  }, []);

  return (
    <Dropdown.Root
      closeOnClick
      placement="bottom-end"
      className={classNames(styles.root, className)}>
      <Dropdown.Button
        className={styles.button}
        variant="text"
        data-event="click"
        data-event-target="gnb_profile">
        <div className={styles.title}>
          <img
            className={styles.image}
            src={profileImageUrl || undefined}
            alt={nickname || 'Profile Image'}
            width={24}
            height={24}
          />
          <p className={styles.nickname}>{nickname}</p>
        </div>
      </Dropdown.Button>
      <Dropdown.Menu className={styles.menu} variant="grow">
        <Flex container justifyContent="space-between" alignItems="center" className={styles.brand}>
          <Link to="/">
            <Heading level={4} className={styles.brandTitle}>
              DOSI Citizen
            </Heading>
          </Link>
          <BrandLikeButton className={styles.likeButton} onClick={handleClickLikeButton} />
        </Flex>
        <div className={styles.divider} />
        <DosiProfileNav direction="column" />
      </Dropdown.Menu>
    </Dropdown.Root>
  );
};
